import * as React from 'react';

import { TextileHelper } from '../../../ts/helpers/TextileHelper';
import {
  ContentSpaceDefinitions
} from '../../../ts/models/ContentDefinitions';
import { isRecommendationType, isSpaceInfoItemType } from '../../../ts/models/ContentType';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { isMetricInfo } from '../../../ts/models/IMetricInfo';
import { ExploreContentApi_ContentType } from '../../../ts/ServerApi/types/IContent';
import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';
import { ServiceLocator } from '../../ServiceLocator';
import { ActionsMenu } from '../ActionsMenu/ActionsMenu';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface ContentCardProps extends SiteUrlsProps {
  readonly content: IContentInfo;
  readonly selected: boolean;
  readonly hoveredOrSelected?: boolean;
  readonly addContentFavorite: (contentId: string, contentType: ExploreContentApi_ContentType) => any;
  readonly removeContentFavorite: (contentId: string, contentIdForFavoriting: string, contentType: ExploreContentApi_ContentType, contentName: string) => any;
  readonly getContentDetail: (content: IContentInfo) => void;
  readonly inWorkbookDatasourcesSubspace: boolean;
  readonly inDatasourceConnectionsSubspace: boolean;
  readonly showActionMenu: boolean;
}

export abstract class ContentCard<Props extends ContentCardProps = ContentCardProps, State = {}>
  extends React.PureComponent<Props, State> {

  private sanitize: ng.sanitize.ISanitizeService;

    constructor(props: Props) {
      super(props);
      this.sanitize = ServiceLocator.get('$sanitize');
    }

    protected getDescription() {
      return TextileHelper.getPlainTextFromTextile(this.props.content.description, this.sanitize);
    }

    protected renderActionsMenu(): JSX.Element {
      return this.props.showActionMenu &&
        <div style={{paddingTop: '2px'}}>
          <ActionsMenu
            targetItems={[ this.props.content ]}
            disabled={ this.props.selected }
            useIcon={true}/>
        </div>;
    }

    protected handleShowTooltip = () => {
      this.props.getContentDetail(this.props.content);
    }
}

export function getContentUrlForItem(content: IContentInfo, urls: SpacesSiteUrls): string | undefined {
  let contentType = content.contentType;
  if (isRecommendationType(contentType)) {
    contentType = 'view';
  }

  // it only makes sense to generate a url for items that have their own space
  // and hence are SpaceInfoItemType('s)
  if (isSpaceInfoItemType(contentType)) {
    const contentDefinition = ContentSpaceDefinitions[contentType];
    if (isMetricInfo(content)) {
      return contentDefinition.contentSpaceUrl(urls, content.luid);
    }
    return contentDefinition.contentSpaceUrl(urls, content.id);
  }
}
